import { Skeleton } from '@/components/ui/skeleton';

interface TableRowsSkeletonProps {
  rows?: number;
  withFilter?: boolean;
}

export default function TableRowsSkeleton({ rows = 4, withFilter = true }: TableRowsSkeletonProps) {
  return (
    <div className="flex flex-col gap-4">
      {withFilter && (
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-full max-w-[400px]" />
          <Skeleton className="h-4 w-32" />
        </div>
      )}
      <div className="flex flex-col divide-y divide-border border-y">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-4 px-2 py-3">
            <Skeleton className="h-4 flex-1 max-w-[280px]" />
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-3 w-3" />
          </div>
        ))}
      </div>
    </div>
  );
}
